/**
 * Fallback calendar URL for a brand sales rep
 */
export const SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL = 'SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL';
